module.exports = __webpack_public_path__ + "img/xinlipingce.0c2178c4.png";